interface PropAndEmitContext<T> {
  props: T;
  emit: (event: string, ...args: unknown[]) => void;
}

export function useLocalObjectProp<T> ({ props, emit }: PropAndEmitContext<T>, propName: string, alias?: string) {
  return new Proxy(props[propName], {
    set (target, property, value) {
      emit(`edit:${propName || alias}`, property, value, target);
      return true;
    },
  });
}

export default useLocalObjectProp;
